import useRemainingMinutes from 'hooks/useRemainingMinutes';
import { LTButton } from '@lambdatestincprivate/lt-components';

import './index.css';

const CongratulationsModalFooter = ({
  handleContinueTour,
  handleTalkToExpert,
  handleSkip,
  handleContinueTesting,
}) => {
  const { kFormatedMinutes } = useRemainingMinutes();
  return (
    <div className="modal-footer-section">
      <div className="remaining-minutes-container">
        * You now have access to {kFormatedMinutes} minutes of free trial
      </div>
      <div className="footer-button-container">
        <div className="footer-button-primary-container">
          <LTButton
            size={LTButton.Size.MEDIUM}
            onClick={handleContinueTour}
            className="modal-footer-button footer-button-primary modal-footer-button-continue-tour"
            variant={LTButton.Variant.PRIMARY}
          >
            Continue Tour
          </LTButton>
          <LTButton
            size={LTButton.Size.MEDIUM}
            variant={LTButton.Variant.DEFAULT}
            onClick={handleTalkToExpert}
            className="modal-footer-button footer-button-secondary modal-footer-button-expert"
          >
            Talk to an expert
          </LTButton>
          <button
            onClick={handleContinueTesting}
            className="modal-footer-button footer-button-secondary modal-footer-button-continue-testing modal-footer-button-hidden"
          >
            Continue Testing
          </button>
        </div>
        <LTButton
          variant={LTButton.Variant.INVISIBLE}
          size={LTButton.Size.MEDIUM}
          className="modal-footer-button footer-skip-now-button"
          onClick={handleSkip}
        >
          Skip for now
        </LTButton>
      </div>
    </div>
  );
};

export default CongratulationsModalFooter;
